import React from "react";
import { Link } from "gatsby";
import { Accordion, AccordionItem } from '@contentful/f36-components'
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { MARKS, INLINES, BLOCKS } from '@contentful/rich-text-types';

const FAQ = ({ content, data, styleId, title }) => {



    // *********************************** IF THE LINKS DO NOT LOAD ON THE FIRST CLICK REVISE THIS SECTION ***********************************
  function getEntryWithId(pageId) {

    // ** First match id with the page

    // Find the parent node based on the parent ID of the matching node
    const matchingIdCrPage = data.allContentfulCrPage.nodes.find(node => node.contentful_id === pageId);
    const matchingIdPdf = data.allContentfulPdf.nodes.find(node => node.contentful_id === pageId);
    const matchingId = matchingIdPdf || matchingIdCrPage; // Returns the first truthy value (i.e., the first match found)

    // ** Get the slug from the matched page
    const matchingEntry = matchingId.slug;
    // ** Get the typename from the matched page
    const matchingType = matchingId.__typename;
    // ** If there is no matching entry gtfo brah   
    if (!matchingEntry) return;

    // Recursive function to find the matching slug and build the URL path

    const buildUrlPath = (items, slug, type) => {

      // Iterate over each node in the current level
      for (const item of items) {

        if (type === "ContentfulPdf") {
          // Found the matching slug and type, construct URL path with .pdf extension
          return `${slug}.pdf`;
        }

        // Check if the current node matches the slug
        if (item.navSlug === slug) {
          // Found the matching slug, construct URL path without .pdf extension
          return `${item.navSlug}`;
        }

        // Check if the current node has navNextLevel
        if (item.navNextLevel) {
          // Recursively search in the navNextLevel

          const nextLevelPath = buildUrlPath(item.navNextLevel, slug);

          // If the matching slug is found in the next level, prepend current slug to the path
          if (nextLevelPath !== '') {
            return `${item.navSlug}/${nextLevelPath}`;
          }
        }
      }

      // If matching slug not found in current nodes or their children, return empty string
      return '';
    };


    const urlPath = buildUrlPath(data.allContentfulCrNavGroup.nodes, matchingEntry, matchingType);
    return (`/${urlPath}`);

  }

    const options = {
        renderText: (text) => {
            return text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []);
        },
        renderMark: {
            [MARKS.BOLD]: (text) => <strong className="font-bold">{text}</strong>,
        },
        renderNode: {
            [INLINES.ENTRY_HYPERLINK]: (node, children) => {
                const referencedEntry = getEntryWithId(node.data.target.sys.id);
                return <Link to={`${referencedEntry}`}>{children}</Link>;
            },
            [INLINES.HYPERLINK]: (node, children) => {
                const referencedEntry = node.data.uri;
                return <Link to={`${referencedEntry}`} target="_blank">{children}</Link>;
            },
            [INLINES.EMBEDDED_ENTRY]: (node, children) => {
                const thisSlug = node.data.target.sys.slug;
                return (
                    <>
                        <a href={thisSlug} className="underline">
                            {children}
                        </a>
                    </>
                );
            },
            [BLOCKS.HEADING_2]: (node, children) => {
                return <h2>{children}</h2>;
            },
            [BLOCKS.TABLE]: (node, children) => {
                const getPathname = () => {
                    if (typeof window !== 'undefined') {
                        return window.location.pathname;
                    }
                    return ''; // Default path or server-side equivalent
                };

                const path = getPathname();


                return <table className='other-table'>{children}</table>;
            }
        }
    };

    return (
        <>
            <div className={content[0].faq[0].title.toLowerCase().replace(/\s+/g, '-')}> 
            {/* add style id here too */}

                {(content[0].faq[0].showName) ? <h2>{content[0].faq[0].title}</h2> : null}

                {content.map((qa) => (
                    <>

                        <Accordion key={qa.id} id={qa.styleId}>
                            <AccordionItem title={qa.question}> 

                                    <p>{renderRichText(qa.answer, options)}</p>

                            </AccordionItem>
                        </Accordion>
                    </>


                ))
                }
            </div>
        </>
    );
}

export default FAQ;